import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import metakLogo from "../images/logo/METAKLOGO.png";
import metakMakeInIndia from "../images/logo/makeinindia.jpg";
import "../styles/header.css";
import { Offcanvas } from "bootstrap";

function resetOffcanvasState() {
  const offcanvasElement = document.getElementById("offcanvasNavbar");
  const offcanvasInstance = Offcanvas.getInstance(offcanvasElement);
  if (offcanvasInstance) {
    offcanvasInstance.dispose(); // Dispose the instance
    new Offcanvas(offcanvasElement); // Reinitialize
  }
}

const ContactInfo = ({ icon, text, link }) => (
  <span className={`top-bar ${link ? "top-bar-email" : "top-bar-contact"}`}>
    <Link
      href={link ? link : "/"}
      style={{ textDecoration: "none" }}
      onClick={(e) => {
        if (link) {
          window.location.href = link;
          e.preventDefault();
        }
      }}
    >
      <span className="top-bar-icon">
        <iconify-icon icon={icon}></iconify-icon>
      </span>
      <span className="top-bar-info">{text}</span>
    </Link>
  </span>
);

const NavItem = ({ to, icon, label, dropdown, isMobile, dropdownVisible, toggleDropdown, hideDropdown }) => (
  <>
    {dropdown ? (
      <li
        className={`nav-item dropdown ${dropdownVisible ? "active" : ""}`}
        onMouseEnter={!isMobile ? toggleDropdown : undefined}
        onMouseLeave={!isMobile ? hideDropdown : undefined}
      >
        <Link
          to={to}
          className="nav-link dropdown-toggle mx-lg-2 text-black"
          role="button"
          aria-expanded={dropdownVisible}
          onClick={(e) => {
            if (isMobile) {
              toggleDropdown(e);
            } else {
              e.preventDefault(); // Prevent navigation for dropdown items
            }
          }}
        >
          <span className="sm-hide-icon">
            <iconify-icon icon={icon} style={{ fontSize: "24px", marginBottom: "4px" }}></iconify-icon>
          </span>
          <span className="label">{label}</span>
        </Link>
        <ul className={`dropdown-menu pt-3 pb-0 ${dropdownVisible ? "show" : ""}`}>
          {dropdown.map(({ to, label }, idx) => (
            <li key={idx}>
              <Link to={to} className="dropdown-item">
                <button className="btn p-0 w-100 text-start" type="button" onClick={hideDropdown} data-bs-dismiss="offcanvas">
                  {label}
                </button>
              </Link>
            </li>
          ))}
        </ul>
      </li>
    ) : (
      <li className="nav-item">
        <Link to={to} className="nav-link mx-lg-2">
          <button className="btn btn-link p-0 text-black text-decoration-none" type="button" data-bs-dismiss="offcanvas">
            <span className="sm-hide-icon">
              <iconify-icon icon={icon} style={{ fontSize: "24px", marginBottom: "4px" }}></iconify-icon>
            </span>
            <span className="label">{label}</span>
          </button>
        </Link>
      </li>
    )}
  </>
);

export default function NavBar() {
  const [isMobile, setIsMobile] = useState(true);
  const [dropdownVisible, setDropdownVisible] = useState(false);

  const toggleDropdown = (e) => {
    if (e) {
      e.preventDefault(); // Prevent navigation if the event exists
    }
    setDropdownVisible(!dropdownVisible);
  };

  const hideDropdown = () => {
    setDropdownVisible(false);
  };

  // Check if the screen is mobile-sized
  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    handleResize(); // Initial check
    window.addEventListener("resize", handleResize);

    const offcanvasElement = document.getElementById("offcanvasNavbar");

    offcanvasElement.addEventListener("hidden.bs.offcanvas", resetOffcanvasState);

    // Cleanup on component unmount
    return () => {
      window.removeEventListener("resize", handleResize);
      offcanvasElement.removeEventListener("hidden.bs.offcanvas", resetOffcanvasState);
    };
  }, []);

  return (
    <>
      <div className="topbar">
        <div className="container">
          <div className="top-bar-txt">
            <ContactInfo icon="ion:mail-outline" text="info@metakindia.com" link="mailto:info@metakindia.com" />
            <ContactInfo icon="ion:call" text="+919312929895" />
          </div>
        </div>
      </div>

      <nav className="top-nav-wrap navbar navbar-expand-lg bg-body-tertiary">
        <div className="container">
          <Link to="/" className="navbar-brand me-auto">
            <img src={metakLogo} alt="Metak Logo" className="img-responsive" />
          </Link>

          <div className="offcanvas offcanvas-end" tabIndex="-1" id="offcanvasNavbar" aria-labelledby="offcanvasNavbarLabel">
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                METAK India
              </h5>
              <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
            </div>
            <div className="offcanvas-body">
              <ul className="navbar-nav justify-content-center flex-grow-1 pe-3 text-center">
                <NavItem to="/" icon="ion:home-outline" label="Home" dropdown={null} />
                <NavItem to="/about-us" icon="ion:person-outline" label="About Us" dropdown={null} />
                <NavItem
                  to="/"
                  icon="mdi:box-outline"
                  label="Products"
                  dropdown={[
                    { to: "/products/walkers", label: "Walkers" },
                    {
                      to: "/products/commode-stool-chairs",
                      label: "Commode Stool & Chairs",
                    },
                    {
                      to: "/products/walking-sticks-crutches",
                      label: "Walking Sticks & Crutches",
                    },
                  ]}
                  isMobile={isMobile}
                  dropdownVisible={dropdownVisible}
                  toggleDropdown={toggleDropdown}
                  hideDropdown={hideDropdown}
                />
                <NavItem to="/contact-us" icon="ion:location-outline" label="Contact" dropdown={null} />
                <NavItem to="/enquiry" icon="ion:mail-outline" label="Enquiry" dropdown={null} />
              </ul>
            </div>
          </div>

          <img src={metakMakeInIndia} alt="Make in India" className="img-responsive" />
          <button
            className="navbar-toggler ms-3"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
        </div>
      </nav>
    </>
  );
}
